import { ModuleLandingPage } from '@/components/module/module-landing-page';
import { adminModule } from '@/config/modules';

export function AdminLandingPage() {
  return (
    <ModuleLandingPage
      title={adminModule.title}
      description={adminModule.description}
      actions={adminModule.landingActions}
    />
  );
}
